<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <table-search
        :style="{ float: 'right' }"
        add-text="新增账号"
        @onSearch="onSearch"
        @editAndAdd="editAndAdd"
      />
    </div>
    <div class="global-table-container">
      <a-tabs
        :active-key="tabkey"
        @change="changeTab"
      >
        <a-tab-pane
          key="0"
          tab="企业账户"
        />
        <a-tab-pane
          key="1"
          tab="服务商账户"
        />
      </a-tabs>
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }"
        @change="changePage"
      />
    </div>
    <account-modal
      ref="formAccount"
      :btn-is-loading="btnIsLoading"
      :account-visible="accountVisible"
      title="新增账户"
      @onCancel="onCancel"
      @handleSubmit="handleSubmit"
    />
  </div>
</template>
<script>
import { columns } from './data/index';
import AccountModal from './modal/index';
export default {
  components: { AccountModal },
  data() {
    return {
      btnIsLoading: false,
      selectData: [],
      columns,
      data: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: true,
      accountVisible: false,
      title: '',
      tabkey: '0',
      keyWord: '',
    };
  },
  mounted() {
    // 获取表格数据
    this.getTableData({
      keyword: this.keyWord,
      role: this.tabkey,
      page: String(this.current),
      pageSize: String(this.pageSize),
    });
  },
  methods: {
    // 获取表格数据
    async getTableData(params) {
      this.loading = true;
      let result = await this.$http.post(
        '/manager/getCompanyManagerList',
        params,
      );
      if (result.data.status === 1) {
        this.loading = false;
        this.total = result.data.data.count;
        this.current = Number(params.page);
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            status: item.status,
            real_name: item.real_name,
            phone: item.phone,
            qichacha_name: item.company.companyInfo.qichacha_name,
            create_time: this.$Format(item.create_time),
          };
          temp.push(obj);
        });
        this.data = temp;
      }
    },
    // 切换tab
    changeTab(value) {
      this.tabkey = value;
      this.getTableData({
        keyword: this.keyWord,
        role: this.tabkey,
        page: '1',
        pageSize: this.pageSize,
      });
    },
    onSearch(value) {
      this.current=1;
      this.keyWord = value;
      this.getTableData({
        keyword: this.keyWord,
        role: this.tabkey,
        page: this.current,
        pageSize: String(this.pageSize),
      });
    },
    // 新增
    editAndAdd() {
      this.accountVisible = true;
      this.$nextTick(() => {
        this.$refs.formAccount.form.resetFields();
      });
    },
    // 确认新增
    handleSubmit() {
      this.$refs.formAccount.form.validateFields(
        async(err, values) => {
          if (!err) {
            this.btnIsLoading=true;
            values.company_id = String(values.company_id);
            let result = await this.$http.post(
              '/manager/addCompanyManager',
              values,
            );
            this.btnIsLoading=false;
            if (result.data.status === 1) {
              this.$message.success('操作成功！');
              this.accountVisible = false;
              this.getTableData({
                keyword: this.keyWord,
                role: this.tabkey,
                page: this.current,
                pageSize: this.pageSize,
              });
            }
          }
        },
      );
    },
    // 取消新增
    onCancel() {
      this.accountVisible = false;
    },
    // 分页
    changePage(pagination) {
      this.current= pagination.current;
      console.log('TCL: changePage -> pagination', pagination.current);
      this.getTableData({
        keyword: this.keyWord,
        role: this.tabkey,
        page: String(pagination.current),
        pageSize: String(pagination.pageSize),
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.client-container {
}
</style>
